<template>
  <div class="cmp-accounting-invoices-vats dbox">
    <Radio2
      :disabled="selectedInvoice.disabled"
      :id="'tax_calculation'"
      :label="$t('tax_calculation')"
      :options="[
        { text: $t('excluding_VAT'), value: '1' },
        { text: $t('including_VAT'), value: '2' },
        { text: $t('no_VAT'), value: '3' },
      ]"
      :value="vat_handling"
      @input="onRadioChange"
    />
    <div
      v-if="vat_handling == 1 || vat_handling == 2"
      class="ut-flex"
      style="border-bottom: 1px solid var(--sprt-5)"
    >
      <TextField2
        :ta="'right'"
        :id="'vat_rate1'"
        :type="'percent'"
        :bb="'none'"
        :placeholder="$t('vat_rate1')"
        :label="$t('vat_rate1')"
        :value="selectedInvoice.invoice.vat_rate1"
        :cw="`clamp(30px, 67px, 250px)`"
        @change="onTextFieldValueChange"
        :disabled="selectedInvoice.disabled"
      />

      <div
        v-if="selectedInvoice && selectedInvoice.invoice"
        class="ut-mr-8px"
        style="flex: 1; text-align: right"
      >
        {{ $dft.curr(selectedInvoice.invoice.vat1_amount || 0) }}
        {{ selectedInvoice.invoiceCurrency.currency_iso }}
      </div>
    </div>
    <div
      v-if="vat_handling == 1 || vat_handling == 2"
      class="ut-flex"
     
    >
      <TextField2
        :ta="'right'"
        :id="'vat_rate2'"
        :type="'percent'"
        :placeholder="$t('vat_rate2')"
        :label="$t('vat_rate2')"
        :value="selectedInvoice.invoice.vat_rate2"
        :bb="'none'"
        :cw="`clamp(30px, 67px
        , 250px)`"
        @change="onTextFieldValueChange"
        :disabled="selectedInvoice.disabled"
      />

      <div
        v-if="selectedInvoice && selectedInvoice.invoice"
        class="ut-mr-8px"
        style="flex: 1; text-align: right"
      >
        {{ $dft.curr(selectedInvoice.invoice.vat2_amount || 0) }}
        {{ selectedInvoice.invoiceCurrency.currency_iso }}
      </div>
    </div>
    <Dropdown2
      :bb="'none'"
      v-if="vat_handling == 3"
      :label="$t('tax_deduction_string')"
      :disabled="selectedInvoice.disabled"
      deselect
      :options="selectedInvoice.tax_deductionsTV"
      :selected="
        selectedInvoice.tax_deductionsTV.find(
          (c) => c.value == selectedInvoice.invoice.tax_type_id_deduction
        )
      "
      :placeholder="$t('tax_deduction_string')"
      v-on:selectedChange="(e) => onDropdownChange('tax_type_id_deduction', e)"
    />
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    selectedInvoice: {
      required: true,
    },
  },
  data: function () {
    return {};
  },
  computed: {
    vat_handling: function () {
      return this.selectedInvoice.invoice.vat_handling;
    },
    borderBottom: function () {
      return this.selectedInvoice.invoice.vat_handling === 3
        ? "1px solid #c8c8c8;"
        : "0px";
    },
  },
  methods: {
    onRadioChange: function ({ value }) {
      this.$emit("change_tax_deduc", { name: "vat_handling", value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("change_tax_deduc", {
        name: "tax_type_id_deduction",
        value: value.value,
      });
    },

    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
  },
};
</script>

<style lang="scss">
.cmp-accounting-invoices-vats {
  .form-group .dt-dropdown {
    margin: 4px 5px !important;
  }

  .dt-checkbox {
    .checkmark,
    input {
      margin-top: 5px;
    }
  }
}
</style>
